import { format as formatFns } from "date-fns";
import { dataLocalDoDia } from "utils/dataCalendario";

// Formata datas. Padrão só com dia/mês/ano: trata como data sem hora (dia de
// calendário, ver utils/dataCalendario). Padrão com hora: instante real no
// fuso local. Antes somava 3h, o que errava o dia de instantes depois das 21h.
const TEM_HORA = /[HhmsaBbkK]/;

const format = (date, pattern = "dd/MM/yyyy") => {
  if (date === undefined || date === null || date === "") return "";
  if (TEM_HORA.test(pattern.replace(/'[^']*'/g, ""))) {
    const d = new Date(date);
    return isNaN(d.getTime()) ? "" : formatFns(d, pattern);
  }
  const dia = dataLocalDoDia(date);
  return dia ? formatFns(dia, pattern) : "";
};

export { format };
